import { ImageShape } from '@enums';

export const convertImageToBase64 = (img: HTMLImageElement, imageShape: ImageShape): string => {
  const canvas: HTMLCanvasElement = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  const size = 100;
  const radius = size / 2;
  canvas.width = size;
  canvas.height = size;

  if (imageShape === ImageShape.CIRCLE) {
    ctx.beginPath();
    ctx.arc(radius, radius, radius, 0, Math.PI * 2);
    ctx.closePath();
    ctx.fill();
    ctx.globalCompositeOperation = 'source-in';
  }

  ctx.drawImage(img, 0, 0, size, size);
  return canvas.toDataURL('image/png');
};
